import { render, staticRenderFns } from "./RestaurantsLoader.vue?vue&type=template&id=6f3e63d1&lang=pug&"
import script from "./RestaurantsLoader.vue?vue&type=script&lang=js&"
export * from "./RestaurantsLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports